import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, isRef as _isRef, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55c69236"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "marketManager" }
const _hoisted_2 = { class: "search_div" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("查找")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("首页宣传位")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("不跳转")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("小程序页面")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("公众号文章")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("template", { slot: "prepend" }, [
  /*#__PURE__*/_createTextVNode("https://")
], -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("停用")
const _hoisted_16 = {
  key: 0,
  class: "sc_div"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "up_sub" }, "支持jpg、png图片", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "up_sub" }, "支持MP4视频", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "up_sub" }, "分辨率345 * 148px", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "up_sub" }, "图片1M，视频10M", -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("确 定")

import { ref, getCurrentInstance, onMounted } from 'vue'
  import pageTitle from '@/components/pageTitle.vue';
  import { ElMessage, ElMessageBox } from 'element-plus';
  import { Plus, CircleClose } from '@element-plus/icons-vue'
  import { getBannerList, createBanner, getBannerDetail, editBanner, delBanner } from '@/axios/smartMarket';
  interface formType {
    id?: number
    position: number
    jump_type: number
    jump_path: string
    sort: number
    status: number
    company_name: string
    company_id: number
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'marketManager',
  setup(__props) {

  let { proxy } = getCurrentInstance() as any;
  let tableData = ref([])
  let marketDialog = ref(false);
  let topath = ref('2');
  let zxURL = ref('');
  let zxType = ref(1)
  let form = ref<formType>({
    id: 0,
    position: 1,
    jump_type: 0,
    jump_path: '',
    sort: 0,
    status: 1,
    company_name: '',
    company_id: 0
  })

  onMounted(()=>{
    getBannerLists();
  })
  function showPage(path:string){
    let val:string = '';
    if(path.includes('supermarket')){
      val = '点餐页'
    }
    else if(path.includes('recharge')){
      val = '储值页'
    }
    else if(path.includes('roomCheck')){
      val = '门店详情页'
    }
    else{
      val = path;
    }
    return val;
  }
  function getBannerLists(){
    let aci = JSON.parse(sessionStorage.getItem('accountInfo') || '')
    getBannerList({
      company_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].company_id
    }).then((data:any) => {
      tableData.value = data[0] ? data :  [];
    }).catch((err:any) => {
    
    })
  }

  //新增、编辑弹窗
  function showAccount(id?:number){
    marketDialog.value = true;
    
    if(id){
      getBannerDetail({
        id: id
      }).then((data:any) => {
        form.value = data;
        zxType.value = data.type;
        zxURL.value = data.resource_url;
        if(data.jump_type == 2){
          if(data.jump_path.includes('recharge')){
            topath.value = '1';
          }
          else if(data.jump_path.includes('supermarket')){
            topath.value = '2';
          }
          else{
            topath.value = '3';
          }
        }
      }).catch((err:any) => {})
    }
  }

  //删除
  function delBar(id:number){
    console.log(id)
    ElMessageBox.confirm('是否删除该轮播图').then(() => {
      delBanner({
        id: id
      }).then((data:any) => {
        ElMessage('删除成功')
        getBannerLists();
      }).catch((err:any) => {
        console.log(err)
      })
    }).catch(() => {
      
    })
  }
  //弹窗关闭
  function closeDia(){
    marketDialog.value = false;
    form.value = {
      id: 0,
      position: 1,
      jump_path: '',
      jump_type: 0,
      status: 1,
      sort: 0,
      company_name: '',
      company_id: 0
    }
    zxURL.value = '';
    topath.value = '2';
  }
  //点击后跳转下拉框
  function typeClick(e:number){
    console.log(e)
    if(e == 2){
      form.value['jump_path'] = '/pages/supermarket/supermarket';
    }
    else{
      form.value['jump_path'] = '';
    }
  }
  //跳转页面下拉框
  function pageClick(e:number){
    if(e == 2){
      form.value['jump_path'] = '/pages/supermarket/supermarket';
    }
    else if(e == 1){
      form.value['jump_path'] = '/memberPage/recharge';
    }
    else{
      form.value['jump_path'] = '/roomSubscribe/roomCheck/roomCheck';
    }
  }
  //图片删除
  function delImg(){
    zxURL.value = '';
  }
  //图片上传
  function beforeAvatarUpload(val:any){
    console.log(val)
    if(val.type.includes('jpeg') || val.type.includes('jpg') || val.type.includes('png') || val.type.includes('mp4')){
      
      let formdata = new FormData();
      formdata.append('file',val);
      formdata.append('project','om');
      formdata.append('modular','peelerCurrency');
      formdata.append('file_type',val.type.includes('image')?'image':'video');
      let urls = `${proxy?.$uploadUrl}/yc_upload/upload/uploads`;
      let xml = new window.XMLHttpRequest();
      xml.open('post',urls,true)
      xml.send(formdata);
      xml.onreadystatechange = function() {
        if(xml.readyState==4 && xml.status==200){
          let infos = JSON.parse(xml.response);
          console.log(infos)
          zxType.value = val.type.includes('image') ? 1 : 2
          zxURL.value = infos.data.url;
        }
      }
    }
    else{
      ElMessage('请选择推荐格式文件')
    }
    return false;
  }
  //确认按钮
  function formClick(){
    if(form.value.jump_type==1 && form.value.jump_path.trim()==''){
      ElMessage('请输入跳转页面')
      return false;
    }
    if(!zxURL.value){
      ElMessage('请选择上传素材')
      return false;
    }
    //新增
    if(!form.value.id){
      let aci = JSON.parse(sessionStorage.getItem('accountInfo') || '')
      createBanner({
        company_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].company_id,
        company_name: aci.company_list[sessionStorage.getItem('checkCompany') || 0].store_name,
        jump_type: form.value.jump_type,
        sort: form.value.sort,
        status: form.value.status,
        type: zxType.value,
        resource_url: zxURL.value,
        jump_path: form.value.jump_path
      }).then((data:any) => {
        ElMessage('新增成功')
        getBannerLists();
        marketDialog.value = false;
      }).catch((err:any) => {})
    }
    else{
      editBanner({
        id: form.value.id,
        company_id: form.value.company_id,
        company_name: form.value.company_name,
        jump_type: form.value.jump_type,
        sort: form.value.sort,
        status: form.value.status,
        type: zxType.value,
        resource_url: zxURL.value,
        jump_path: form.value.jump_path
      }).then((data:any) => {
        ElMessage('编辑成功')
        getBannerLists();
        marketDialog.value = false;
      }).catch((err:any) => {})
    }
  }



return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(pageTitle, { title: "营销位管理" }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: getBannerLists
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showAccount()))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_table, {
        data: _unref(tableData),
        border: "",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "sort",
            label: "排序",
            width: "80px"
          }),
          _createVNode(_component_el_table_column, {
            label: "素材",
            width: "270px"
          }, {
            default: _withCtx((scope) => [
              (scope.row.type == 1)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "sc_info",
                    src: scope.row.resource_url
                  }, null, 8, _hoisted_5))
                : (_openBlock(), _createElementBlock("video", {
                    key: 1,
                    class: "sc_info",
                    src: scope.row.resource_url,
                    controls: ""
                  }, null, 8, _hoisted_6))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "宣传位",
            width: "150px"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.position==1?'首页':'') + _toDisplayString(scope.row.position==2?'订房页':''), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "jump_path",
            label: "点击后跳转"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(showPage(scope.row.jump_path)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "状态",
            width: "150px"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.status==0?'停用':'启用'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            fixed: "right",
            width: "180px"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                text: "",
                type: "primary",
                onClick: ($event: any) => (showAccount(scope.row.id))
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                text: "",
                type: "primary",
                onClick: ($event: any) => (delBar(scope.row.id))
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createVNode(_component_el_dialog, {
      title: _unref(form).id?'编辑营销位':'新增营销位',
      modelValue: _unref(marketDialog),
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(marketDialog) ? (marketDialog).value = $event : marketDialog = $event)),
      onClose: closeDia
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(form),
          "label-position": "left",
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "宣传位" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _unref(form).position,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).position) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "点击后跳转" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _unref(form).jump_type,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).jump_type) = $event)),
                  onChange: typeClick
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 0 }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 2 }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (_unref(form).jump_type==2)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "跳转页面"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(topath),
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(topath) ? (topath).value = $event : topath = $event)),
                      placeholder: "请选择活动区域",
                      onChange: pageClick
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "储值页",
                          value: "1"
                        }),
                        _createVNode(_component_el_option, {
                          label: "点餐页",
                          value: "2"
                        }),
                        _createVNode(_component_el_option, {
                          label: "门店详情页",
                          value: "3"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(form).jump_type==1)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "跳转页面"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(form).jump_path,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).jump_path) = $event))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, { label: "排序" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(form).sort,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).sort) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _unref(form).status,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).status) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 0 }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "上传素材" }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  (_unref(zxURL))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createVNode(_component_el_icon, {
                          class: "el-icon-circle-close",
                          onClick: delImg
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(CircleClose))
                          ]),
                          _: 1
                        }),
                        (_unref(zxType)==1)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _unref(zxURL),
                              class: "upImg"
                            }, null, 8, _hoisted_17))
                          : (_openBlock(), _createElementBlock("video", {
                              key: 1,
                              src: _unref(zxURL),
                              class: "upImg"
                            }, null, 8, _hoisted_18))
                      ]))
                    : (_openBlock(), _createBlock(_component_el_upload, {
                        key: 1,
                        "show-file-list": false,
                        class: "avatar-uploader",
                        action: "",
                        "before-upload": beforeAvatarUpload
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, { class: "el-icon-plus avatar-uploader-icon" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Plus))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })),
                  _hoisted_19,
                  _hoisted_20,
                  _hoisted_21,
                  _hoisted_22
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, { onClick: closeDia }, {
                  default: _withCtx(() => [
                    _hoisted_23
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: formClick
                }, {
                  default: _withCtx(() => [
                    _hoisted_24
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ], 64))
}
}

})